import ServerNotReachableError from "errors/ServerNotReachableError"

const call = async (f, ...args) => {
  let response
  try {
    response = await f(...args)
  } catch (e) {
    // message.destroy()

    Object.keys(e)
      .filter((k) => k !== "toJSON")
      .forEach((k) => console.log(`e.${k}`, e[k]))
    if (!e.isAxiosError) {
      throw e
    }

    response = e.response

    if (!response) {
      throw new ServerNotReachableError("Maybe server is not running")
    }

    console.log("response ---", response)

    // FIXME: handle all server errors here
    if (response.status === 403) {
      // const { errors } = response.data

      // if (typeof errors[0] === "string") {
      //   message.error(errors[0])
      //   return response
      // }

      // message.error("Oops!! something went wrong")
      return response
    }

    if (response.status >= 500) {
      throw e
    }
  }
  return response
}

export default call
